/**
 * Authentication related types
 */

export interface User {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  full_name: string;
  role: UserRole;
  is_active: boolean;
  is_verified: boolean;
  organization_id: string;
  created_at: string;
  updated_at: string;
}

export interface UserMe extends User {
  organization_name: string;
}

export interface ApiKeyInfo {
  id: string;
  name: string;
  is_active: boolean;
  created_at: string;
}

export interface ApiKeyCreateResponse extends ApiKeyInfo {
  key: string;
}

export enum UserRole {
  USER = 'user',
  ORGANIZATION_ADMIN = 'organization_admin',
  ADMIN = 'admin',
}

export interface Organization {
  id: string;
  name: string;
  description: string | null;
  settings: Record<string, any> | null;
  is_active: boolean;
  validate_through_database?: boolean;
  user_count?: number;
  created_at: string;
  updated_at: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  organization_id?: string; // Optional: GUID of organization to join, or leave empty to create new
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export interface AuthState {
  user: UserMe | null;
  tokens: TokenResponse | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}
